// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Floating Crypto Promo Tab === */
.crypto-tab {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  background: linear-gradient(145deg, #7b2eff, #a85bff);
  color: #fff;
  padding: 0.7rem 1.3rem;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: 0 0 15px rgba(160, 70, 255, 0.4);
  cursor: pointer;
  z-index: 3000;
  animation: floatPulse 3s infinite ease-in-out;
  transition: all 0.3s ease;
}

.crypto-tab:hover {
  transform: scale(1.05);
  box-shadow: 0 0 25px rgba(180, 90, 255, 0.8);
}

/* === Floating Animation === */
@keyframes floatPulse {
  0%, 100% { transform: translateY(5); }
  50% { transform: translateY(50px); }
}

/* === Modal Overlay === */
.crypto-modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 50vw; height: 100vh;
  background: rgba(10, 0, 25, 0.85);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 4000;
}

/* === Modal Box === */
.crypto-modal {
  background: rgba(35, 0, 65, 0.9);
  border: 1px solid rgba(160, 70, 255, 0.3);
  border-radius: 16px;
  padding: 2rem;
  max-width: 360px;
  text-align: center;
  box-shadow: 0 0 25px rgba(180, 90, 255, 0.5);
  animation: fadeIn 0.4s ease;
}

.crypto-modal h3 {
  color: #b877ff;
  margin-bottom: 0.5rem;
  text-shadow: 0 0 10px rgba(185, 90, 255, 0.8);
}

.crypto-modal p {
  color: #cbbdf7;
  font-size: 0.9rem;
  line-height: 1.5;
}

.crypto-modal .qr-code {
  width: 180px;
  height: 180px;
  margin: 1rem auto;
  border-radius: 12px;
  border: 2px solid #b877ff;
  box-shadow: 0 0 30px rgba(185, 90, 255, 0.4);
}

/* Pulse Glow on QR */
@keyframes pulseGlow {
  0%, 100% { box-shadow: 0 0 25px rgba(180, 90, 255, 0.5); }
  50% { box-shadow: 0 0 40px rgba(185, 90, 255, 0.8); }
}
.qr-code.pulse {
  animation: pulseGlow 2.5s infinite ease-in-out;
}

/* === Wallet === */
.wallet-address {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 0.6rem 1rem;
  font-family: "Courier New", monospace;
  font-size: 0.85rem;
  color: #d4baff;
  word-break: break-all;
}

.copy-btn.purple {
  background: linear-gradient(145deg, #a84dff, #6a1b9a);
  border: none;
  color: white;
  border-radius: 6px;
  padding: 0.3rem 0.7rem;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.25s ease;
}

.copy-btn.purple:hover {
  background: linear-gradient(145deg, #b877ff, #8e24aa);
  box-shadow: 0 0 12px rgba(180, 90, 255, 0.6);
}

/* Fade in */
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
`, "",{"version":3,"sources":["webpack://./src/components/CryptoPromo.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;EACf,aAAa;EACb,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,+BAA+B;AAC/B;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,aAAa;EAC1B,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;EAChC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,qBAAqB;AACrB;EACE,WAAW,4CAA4C,EAAE;EACzD,MAAM,4CAA4C,EAAE;AACtD;AACA;EACE,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA,YAAY;AACZ;EACE,OAAO,UAAU,EAAE,qBAAqB,EAAE;EAC1C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC","sourcesContent":["/* === Floating Crypto Promo Tab === */\n.crypto-tab {\n  position: fixed;\n  bottom: 1.5rem;\n  right: 1.5rem;\n  background: linear-gradient(145deg, #7b2eff, #a85bff);\n  color: #fff;\n  padding: 0.7rem 1.3rem;\n  border-radius: 50px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  box-shadow: 0 0 15px rgba(160, 70, 255, 0.4);\n  cursor: pointer;\n  z-index: 3000;\n  animation: floatPulse 3s infinite ease-in-out;\n  transition: all 0.3s ease;\n}\n\n.crypto-tab:hover {\n  transform: scale(1.05);\n  box-shadow: 0 0 25px rgba(180, 90, 255, 0.8);\n}\n\n/* === Floating Animation === */\n@keyframes floatPulse {\n  0%, 100% { transform: translateY(5); }\n  50% { transform: translateY(50px); }\n}\n\n/* === Modal Overlay === */\n.crypto-modal-overlay {\n  position: fixed;\n  top: 0; left: 0;\n  width: 50vw; height: 100vh;\n  background: rgba(10, 0, 25, 0.85);\n  backdrop-filter: blur(6px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 4000;\n}\n\n/* === Modal Box === */\n.crypto-modal {\n  background: rgba(35, 0, 65, 0.9);\n  border: 1px solid rgba(160, 70, 255, 0.3);\n  border-radius: 16px;\n  padding: 2rem;\n  max-width: 360px;\n  text-align: center;\n  box-shadow: 0 0 25px rgba(180, 90, 255, 0.5);\n  animation: fadeIn 0.4s ease;\n}\n\n.crypto-modal h3 {\n  color: #b877ff;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 0 10px rgba(185, 90, 255, 0.8);\n}\n\n.crypto-modal p {\n  color: #cbbdf7;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.crypto-modal .qr-code {\n  width: 180px;\n  height: 180px;\n  margin: 1rem auto;\n  border-radius: 12px;\n  border: 2px solid #b877ff;\n  box-shadow: 0 0 30px rgba(185, 90, 255, 0.4);\n}\n\n/* Pulse Glow on QR */\n@keyframes pulseGlow {\n  0%, 100% { box-shadow: 0 0 25px rgba(180, 90, 255, 0.5); }\n  50% { box-shadow: 0 0 40px rgba(185, 90, 255, 0.8); }\n}\n.qr-code.pulse {\n  animation: pulseGlow 2.5s infinite ease-in-out;\n}\n\n/* === Wallet === */\n.wallet-address {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  padding: 0.6rem 1rem;\n  font-family: \"Courier New\", monospace;\n  font-size: 0.85rem;\n  color: #d4baff;\n  word-break: break-all;\n}\n\n.copy-btn.purple {\n  background: linear-gradient(145deg, #a84dff, #6a1b9a);\n  border: none;\n  color: white;\n  border-radius: 6px;\n  padding: 0.3rem 0.7rem;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.25s ease;\n}\n\n.copy-btn.purple:hover {\n  background: linear-gradient(145deg, #b877ff, #8e24aa);\n  box-shadow: 0 0 12px rgba(180, 90, 255, 0.6);\n}\n\n/* Fade in */\n@keyframes fadeIn {\n  from { opacity: 0; transform: scale(0.9); }\n  to { opacity: 1; transform: scale(1); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
